import React from 'react';
import './blog-post.css';
import wad from './pictures/wad.jpg';


//import reportWebVitals from './reportWebVitals';

const WAD22 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Winter Career Prep Dinner Event Recap</h2>
                    <p className="site-post-meta">February 14th, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        On February 2nd, WiC held our Career Prep Dinner. It was a major success and we want to thank everyone
                        who came! We had a bunch of great resources to share throughout the night and we hope you all learned 
                        so much. 

                        We started the event with an elevator pitch workshop and got to practice our pitches with one another.
                        Then our former chair of ACM-W, Rachel Ye, got to share her experience with us and gave us many
                        resources for getting into industry. She gave recruiting advice and her experience with imposter syndrome
                        in college and the industry. She also shared her resume with us, CSE classes she found helpful in industry,
                        and her actual experience in industry. Lastly we got a quick workshop from Allen School peer advisors
                        who shared career prep resources, including for gaining technical experience.
                        
                        Thank you again everyone for coming to the event. We hope you were able to learn new things all while
                        enjoying dinner with us!
                    </p>
                    <img src={wad} alt="Women in Computing members with Speaker"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default WAD22;